import { useEffect } from 'react';
import useGradesTableStore from '../store/useGradesTableStore';
import useAssignments from './useAssignments';
import useSubmissions from './useSubmissions';
import { mergeTableData } from '../utils';

const useStudentTableData = () => {
  useAssignments();
  useSubmissions();

  const isLoading = useGradesTableStore(state => state.isLoading);
  const assignments = useGradesTableStore(state => state.assignments);
  const submissions = useGradesTableStore(state => state.submissions);
  const setStore = useGradesTableStore(state => state.setStore);

  useEffect(() => {
    if (!assignments.length) return;

    const mergedData = mergeTableData(assignments, submissions);
    setStore({ tableData: mergedData });
  }, [isLoading]);
};

export default useStudentTableData;
